<mat-accordion>
  <mat-expansion-panel [(expanded)]="expanded" class="config-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>Search box hint configuration</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <div class="wrap">
        <mat-checkbox formControlName="show" class="show-searchbox-hint">Show hint</mat-checkbox>
        @if (form.get('show').value) {
          <mat-form-field appearance="fill" class="count-of-pages">
            <mat-label>Count of pages</mat-label>
            <input matInput type="number" min="0" formControlName="minCountOfPagesToShowHint">
          </mat-form-field>
        }
      </div>
    </form>
  </mat-expansion-panel>
</mat-accordion>